import { render } from "./postCloseConnect.vue?vue&type=template&id=161ea565"
import script from "./postCloseConnect.vue?vue&type=script&lang=js"
export * from "./postCloseConnect.vue?vue&type=script&lang=js"

import "./postCloseConnect.vue?vue&type=style&index=0&id=161ea565&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__